import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import axios from 'axios';
import store from './store'
import ImageLoader from './components/Common/imageLoader'
import VueElementLoading from 'vue-element-loading'
import ServerError from "./components/Common/500.vue"
Vue.component('VueElementLoading', VueElementLoading)
import ImageMagnifier from 'vue-image-magnifier'
Vue.use(ImageMagnifier)
import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
import OwlCarousel from 'vue-owl-carousel'
Vue.component('OwlCarousel', OwlCarousel)
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

Vue.use(Viewer)
import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing);
import VueTimeago from 'vue-timeago'
Vue.use(VueTimeago, {
    name: 'Timeago', // Component name, `Timeago` by default
    locale: 'en', // Default locale
    // We use `date-fns` under the hood
    // So you can use all locales from it
    locales: {
        'zh-CN': require('date-fns/locale/zh_cn'),
        ja: require('date-fns/locale/ja')
    }
})
Vue.component('apexchart', VueApexCharts)
Vue.component('ImageLoader', ImageLoader)
Vue.component('ServerError', ServerError)
Vue.config.productionTip = false
window.axios = require('axios')

axios.defaults.baseURL = 'http://13.126.63.17';
Vue.prototype.baseURL = "http://13.126.63.17"
Vue.prototype.mediaURL = "http://13.126.63.17/u/"
Vue.prototype.frontendURL = "http://localhost:8080/"
    // axios.defaults.baseURL = 'http://192.168.48.197:2000';
    // Vue.prototype.baseURL = "http://192.168.48.197:2000"
    // Vue.prototype.mediaURL = "http://192.168.48.197:2000/u/"

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')